import React from 'react'
import UserRouter from 'routes/Components/UserRouter'
import { Routes, Route } from 'react-router'
import CorporateDashboard from 'modules/CorporateDashboardPage2/Container'
import corporateDashboardPage2 from 'modules/CorporateDashboardPage2'

const Routers = ({ token,permissions }) => {
  const isAuthenticated = Boolean(token)
  return (
    <Routes>
      <Route
        path="/*"
        element={<UserRouter isAuthenticated={isAuthenticated}  permissions={permissions} />}
      />
    </Routes>
  )
}

export default Routers
